// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"bec203f3afe1d11b9e3d","303":"bb888fdf814d5aed9939","495":"1f7e0f6d323e3df79208"}[chunkId] + ".js";
};